export const emailSent = {
  instruction:
    'Por favor siga as instruções que nós enviamos para sua caixa de entrada para que consiga criar uma nova senha.'
}
